import React from 'react';
import { Skeleton } from 'primereact/skeleton';

interface OutcomeStatusItem {
  tierName: string | null;
  tierOutcome: string;
  passedMeasures: number;
  totalMeasures: number;
}

interface OutcomeStatusTableProps {
  data: OutcomeStatusItem[];
  loading?: boolean;
  error?: string | null;
}

const OutcomeStatusTableComponent: React.FC<OutcomeStatusTableProps> = ({
  data,
  loading = false,
  error
}) => {

  if (error) {
    return (
      <div className="outcome-status-table-container">
        <div className="alert alert-danger">
          <strong>Error:</strong> {error}
        </div>
      </div>
    );
  }
  
  if (loading) {
    return (
      <div style={{ marginLeft: 8 }}>
        <div style={{ display: 'flex', gap: '20px', marginBottom: 8 }}>
          <Skeleton width="160px" height="24px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
          <Skeleton width="160px" height="24px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
          <Skeleton width="160px" height="24px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
        </div>
        <div style={{ display: 'flex', gap: '20px', marginBottom: 8 }}>
          <Skeleton width="160px" height="24px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
          <Skeleton width="160px" height="24px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
          <Skeleton width="160px" height="24px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
        </div>
        <div style={{ display: 'flex', gap: '20px' }}>
          <Skeleton width="160px" height="20px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
          <Skeleton width="160px" height="20px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
          <Skeleton width="160px" height="20px" style={{ backgroundColor: '#e9ecef', borderRadius: '4px' }} />
        </div>
      </div>
    );
  }
  
  if (!data || data.length === 0) {
    return (
        <span>No outcome data available.</span>
    );
  }

  return (
    <div className="outcome-status-table-container">
        <table style={{
          borderCollapse: 'collapse',
          textAlign: 'center',
          marginLeft: 8
        }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #1976d2' }}>
              {data?.map((item, index) => (
                <th
                  key={index}
                  style={{
                    fontWeight: 'bold',
                    paddingBottom: 4,
                    paddingLeft: 20,
                    paddingRight: 20,
                    borderRight: index < data.length - 1 ? '2px solid #1976d2' : undefined
                  }}
                >
                  {item.tierName || `Tier ${index + 1}`}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '2px solid #1976d2' }}>
              {data.map((item, index) => (
                <td
                  key={index}
                  style={{
                    padding: '4px 20px',
                    borderRight: index < data.length - 1 ? '2px solid #1976d2' : undefined,
                    fontWeight: 'bold',
                    color: item.tierOutcome?.toLowerCase() === 'met' ? '#28a745' : 
                           item.tierOutcome?.toLowerCase() === 'unmet' ? '#dc3545' : '#6c757d'
                  }}
                >
                  {item.tierOutcome}
                </td>
              ))}
            </tr>
            <tr>
              {data.map((item, index) => (
                <td
                  key={index}
                  style={{
                    padding: '4px 20px',
                    borderRight: index < data.length - 1 ? '2px solid #1976d2' : undefined,
                    fontSize: '0.9em',
                    color: '#6c757d'
                  }}
                >
                  {item.totalMeasures > 0 ? 'Passed Measures:' + item.passedMeasures +'/' + item.totalMeasures:'Not Applicable'}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
    </div>
  );
};

export default OutcomeStatusTableComponent;